<div *ngIf="kid" style="height: 100%; display: flex; flex-direction: column;">
    <h3 igxCardHeaderTitle>{{ kid.name }}</h3>
    <igx-tabs style="flex: 1 1 auto">
        <igx-tab-item>
            <igx-tab-header>
                <span igxTabHeaderLabel>Програми</span>
            </igx-tab-header>
            <igx-tab-content>
                <igx-accordion>
                    <igx-expansion-panel *ngFor="let package of sortPackages()">
                        <igx-expansion-panel-header>
                            <igx-expansion-panel-title>{{ package.program.name}}</igx-expansion-panel-title>
                            <igx-expansion-panel-description>{{ package.price | currency: 'BGN' }} - Дати {{
                                getPeriod(package) }}
                            </igx-expansion-panel-description>
                        </igx-expansion-panel-header>
                        <igx-expansion-panel-body>
                            <igx-grid [data]="sortParticipations(package)" width="800px" height="250px">
                                <igx-column header="Спорт" field="package">
                                    <ng-template igxCell let-cell="cell">
                                        {{ getSport(cell.value) }}
                                    </ng-template>
                                </igx-column>
                                <igx-column header="Ниво" field="package">
                                    <ng-template igxCell let-cell="cell">
                                        {{ getLevel(cell.value) }}
                                    </ng-template>
                                </igx-column>
                                <igx-column header="Дата" field="date" dataType="date"></igx-column>
                                <igx-column header="Отсъствал" field="absent" dataType="boolean"></igx-column>
                            </igx-grid>
                        </igx-expansion-panel-body>
                    </igx-expansion-panel>
                </igx-accordion>
            </igx-tab-content>
        </igx-tab-item>
        <igx-tab-item>
            <igx-tab-header>
                <span igxTabHeaderLabel>Плащания</span>
            </igx-tab-header>
            <igx-tab-content>
                <igx-accordion>
                    <igx-expansion-panel *ngFor="let package of sortPackages()">
                        <igx-expansion-panel-header>
                            <igx-expansion-panel-title>{{ package.program.name}}</igx-expansion-panel-title>
                            <igx-expansion-panel-description>{{ package.price | currency: 'BGN' }} - Дати {{
                                getPeriod(package) }}
                            </igx-expansion-panel-description>
                        </igx-expansion-panel-header>
                        <igx-expansion-panel-body>
                            <igx-grid [data]="package.payments | sorting" width="800px" height="250px">
                                <igx-column header="Дата" dataType="date" field="date"></igx-column>
                                <igx-column header="Сума" [summaryFormatter]="formatCurrency" dataType="currency" field="amount" [hasSummary]="true" [summaries]="sumSummary"></igx-column>
                            </igx-grid>
                        </igx-expansion-panel-body>
                    </igx-expansion-panel>
                </igx-accordion>
            </igx-tab-content>
        </igx-tab-item>
    </igx-tabs>
    <button style="align-self: flex-end;" igxButton igxRipple (click)="done.emit()">Затвори</button>
</div>
